<template>
  <!-- 生成签约链接的dialog模态框 -->
  <el-dialog
    v-if="visible"
    title="岗位发布"
    :visible.sync="visible"
    :before-close="handleOuterClose"
    width="54%"
    custom-class="create_position"
    append-to-body
    class="create-task"
  >
    <div class="form-content">
      <div class="quick-create-btn">
        <el-popover
          placement="right"
          width="200"
          trigger="click">
          <el-select
              v-model="task_id"
              filterable
              clearable
              placeholder="请选择关联任务"
              @change="selectTask"
            >
              <el-option
                v-for="item in taskList"
                :label="item.title"
                :key="item.id"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button slot="reference"
              type="primary"
              size="mini"
              >快速创建
            </el-button>
        </el-popover>
        
      </div>
      <el-form
        ref="companyForm"
        :inline="true"
        :model="formData"
        label-width="130px"
      >
        <el-col :span="12" v-for="(item, index) in formList" :key="index">
          <el-form-item
            :label="item.label"
            :prop="item.props"
            :rules="[
              {
                required: item.required,
                message: '请输入' + item.label,
                trigger: 'blur',
              },
            ]"
          >
            <template v-if="item.type == 'input'">
              <el-input
              class="input"
                :placeholder="item.placeholder"
                v-model="formData[item.props]"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'textarea'">
              <el-input
              class="input"

                type="textarea"
                v-model="formData[item.props]"
              ></el-input>
            </template>
            <template v-else-if="item.type == 'picker'">
              <el-select
              class="select"
                v-model="formData[item.props]"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item1, index1) in item.selectOption"
                  :key="index1"
                  :label="item1.label"
                  :value="item1.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.type == 'multiplePicker'">
              <el-select
              class="select"

                v-model="formData[item.props]"
                placeholder="请选择"
                clearable
                filterable
                multiple
              >
                <el-option
                  v-for="(item1, index1) in item.selectOption"
                  :key="index1"
                  :label="item1.label"
                  :value="item1.value"
                ></el-option>
              </el-select>
            </template>
            <template v-else-if="item.type == 'cascader'">
              <el-cascader
              class="cascader"
                v-model="formData[item.props]"
                placeholder="请选择"
                clearable
                filterable
                :checkStrictly="true"
                :show-all-levels="false"
                :props="{ multiple: item.multiple }"
                :options="item.selectOption"
              >
              </el-cascader>
            </template>
            <template v-else-if="item.type == 'salary'">
              <div style="width: 240px;">
                <el-col :span="10">
                <el-input
                  class="salary-input"
                  v-model="formData.min_salary"
                  placeholder="最低薪资"
                />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    class="salary-input"
                    v-model="formData.max_salary"
                    placeholder="最高薪资"
                  />
                </el-col>
                <el-col :span="2">
                  <el-tooltip class="item" effect="dark" content="如若填写相同薪资，则展示固定薪资" placement="right">
                    <i class="el-icon-warning"></i>
                  </el-tooltip>
                </el-col>
              </div>
              
            </template>
            <template v-else-if="item.type == 'age'">
              <div style="width: 240px;">
                <el-col :span="10">
                <el-input
                  class="salary-input"
                  v-model="formData.min_age"
                  placeholder="最小年龄"
                />
                </el-col>
                <el-col :span="2" class="text-center">
                  <span class="text-gray-500">-</span>
                </el-col>
                <el-col :span="10">
                  <el-input
                    class="salary-input"
                    v-model="formData.max_age"
                    placeholder="最大年龄"
                  />
                </el-col>
              </div>
              
            </template>
            <template v-else-if="item.type == 'mapPicker'">
              <TencentMapPicker
                class="map-picker"
                v-model="formData[item.props]"
                :placeholder="item.placeholder"
                :region-name="workCityRegionName"
                :region-codes="workCityRegionCodes"
                @confirmMap="handleConfirmMap"
              />
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="margin-bottom: 10px;padding-left: 20px;">
          <div style="margin-bottom: 6px;">
            职位介绍
          </div>
          <el-input
            type="textarea"
            rows="5"
            placeholder="请输入职位介绍"
            maxlength="200"
            show-word-limit
            v-model="formData.job_remark"
          >
          </el-input>
        </div>
        </el-col>
        
      </el-form>
      <div class="btn">
        <el-button
          size="medium"
          type="primary"
          :disabled="loadingStaus"
          @click="saveConfirm"
          >保存</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import json from "../../../../public/citys.json";
import { gettreeList, tog_SALARY_TYPE_LIST,SALARY_TYPE_VALUE_MAP } from "@/utils/utils";
import TencentMapPicker from "@/components/TencentMapPicker.vue";

export default {
  components: { TencentMapPicker },
  // props:{
  //   id: {
  //     type: String,
  //     default: '',
  //   },
  //   type: {
  //     type: String,
  //     default: '',
  //   },
  // },
  data() {
    return {
      taskList: [],
      task_id: '',
      visible: false,
      json,
      formList: [
        {
          required: true,
          label: "岗位名称",
          type: "input",
          props: "recruit_post",
          value: "",
          placeholder: "请输入岗位名称",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位标签",
          type: "multiplePicker",
          props: "tag_ids",
          value: [],
          selectOption: [],
          placeholder: "请选择岗位标签",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "行业类型",
          type: "cascader",
          props: "category_ids",
          value: [],
          multiple: true,
          selectOption: [],
          placeholder: "请选择行业类型",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "用工人数",
          type: "input",
          props: "worked_num",
          value: "",
          placeholder: "请输入用工人数",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "年龄要求",
          props: "min_age",
          disabled: false,
          type: "age"
        },
        {
          required: true,
          label: "学历要求",
          type: "picker",
          props: "minimum_education",
          selectOption: [
            { label: "不限", value: "0" },
            { label: "小学", value: "1" },
            { label: "初中", value: "2" },
            { label: "高中", value: "3" },
            { label: "大专", value: "4" },
            { label: "本科及以上", value: "5" },
          ],
          placeholder: "请选择学历要求",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "工作地点",
          type: "cascader",
          props: "work_city",
          value: "",
          selectOption: json.data,
          valueLevel: "more",
          placeholder: "请选择工作地点",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "详细地点",
          type: "mapPicker",
          props: "address",
          placeholder: "请点击地图选点",
          value: "",
          disabled: false,
          show: true,
        },
        {
          label: "联系人电话",
          type: "input",
          props: "contact_number",
          placeholder: "请输入联系人电话",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位状态",
          type: "picker",
          props: "status",
          placeholder: "请选择岗位状态",
          selectOption: [
            { label: "未开始", value: 0 },
            { label: "进行中", value: 1 },
            { label: "已完成", value: 2 },
            { label: "已暂停", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "结算方式",
          type: "picker",
          props: "salary_type",
          selectOption: tog_SALARY_TYPE_LIST,
          placeholder: "请选择结算方式",
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "薪资范围",
          type: "salary",
          props: "min_salary",
          placeholder: "请输入薪资",
          value: "",
          show: true,
        },
        {
          required: true,
          label: "工作性质",
          type: "picker",
          props: "work_type",
          placeholder: "请选择工作性质",
          selectOption: [
            { label: "全职", value: 1 },
            { label: "兼职", value: 2 },
            { label: "实习", value: 3 },
          ],
          value: "",
          disabled: false,
          show: true,
        },
        {
          required: true,
          label: "岗位时效",
          type: "picker",
          props: "renew_type",
          placeholder: "请选择岗位时效",
          selectOption: [
            { label: "1个月", value: 1 },
            { label: "2个月", value: 2 },
            { label: "3个月", value: 3 },
          ],
          disabled: false,
          show: true,
        },
        {
          required: false,
          label: "同步到支付宝就业",
          type: "picker",
          props: "is_sync_alipay",
          placeholder: "请选择",
          selectOption: [
            { label: "否", value: 0 },
            { label: "是", value: 1 },
          ],
          disabled: false,
          show: true,
        },
      ],
      loadingStaus: true,
      loadingText: "正在提交中……",
      formData: {
        renew_type: 1,
        is_sync_alipay: 0,
      },
    };
  },
  computed: {
    // 工作地点为 code 数组时，供地图选点组件使用
    workCityRegionCodes() {
      const w = this.formData.work_city;
      if (!Array.isArray(w) || w.length === 0) return [];
      const isCode = w.every((v) => typeof v === 'string' && /^\d{4,6}$/.test(v));
      return isCode ? w : [];
    },
    // 工作地点对应的区域名称（用于地图搜索范围）：code 时从树解析，name 时取最后一级
    workCityRegionName() {
      const w = this.formData.work_city;
      if (!Array.isArray(w) || w.length === 0) return '';
      const isCode = w.every((v) => typeof v === 'string' && /^\d{4,6}$/.test(v));
      if (isCode) {
        const name = this.getRegionLabelByCodes(json.data, w);
        return name || '';
      }
      return w[w.length - 1] || '';
    },
  },
  watch: {
    "formData.min_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.min_salary = "";
      }
    },
    "formData.max_salary"(val) {
      if (val && !this.formData.salary_type) {
        this.$message.error("请先选择结算方式");
        this.formData.max_salary = "";
      }
    },
  },
  methods: {
    // 根据省市区 value 数组从树中取最后一级的 label（用于地图搜索 region）
    getRegionLabelByCodes(tree, codes) {
      if (!tree || !codes || !codes.length) return '';
      let list = tree;
      let label = '';
      for (let i = 0; i < codes.length; i++) {
        const node = list.find((n) => n.value === codes[i]);
        if (!node) return label;
        label = node.label || '';
        list = node.children || [];
      }
      return label;
    },
    handleConfirmMap(payload) {
      console.log("handleConfirmMap", payload);
      this.formData.address = payload.address;
      this.formData.lat = payload.lat;
      this.formData.lon = payload.lon;
    },
    open(type,id){
      this.type = type;
      this.id = id;
      this.visible = true;
      this.init();
    },
    //关闭外层dialog小×
    handleOuterClose() {
      this.$refs.companyForm.resetFields();
      this.visible = false;
      this.task_id = '';
      this.formData = {
        renew_type: 1,
        is_sync_alipay: 0,
      }
    },
    async getDailyTaskIndustryList() {
      let res = await this.$api.getDailyTaskIndustryList();
      this.formList[2].selectOption = gettreeList(
        res,
        "industry_type_name",
        "id"
      );
    },
    selectTask(e){
      let arr = this.taskList.filter(item => e == item.id)[0]
      this.formData = {
        ...this.formData,
        renew_type: 1,
        is_sync_alipay: 0,
        recruit_post:arr.title,
        work_city:[arr.province,arr.city,arr.area],
        minimum_education: '' + arr.min_qualification,
        min_salary: arr.min_salary,
        max_salary: arr.max_salary,
        worked_num: arr.person_num,
        address:arr.address,
        lat: arr.lat,
        lon: arr.lon,
        salary_type: SALARY_TYPE_VALUE_MAP[parseInt(arr.salary_type)],
      };
    },
    async getQuickMissionList() {
      let res = await this.$api.get_quick_mission_list();
      this.taskList = res
    },
    async getDailyPostTagList() {
      let res = await this.$api.getDailyPostTagList();
      this.formList[1].selectOption = gettreeList(res, "name", "id");
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs["companyForm"].validate((valid) => {
        if (valid) {
          if (!this.validateSalaryRange()) return;
          this.formSubmit();
        } else {
          this.$message.error("数据验证失败，请检查必填项数据！");
        }
      });
      return true;
    },
    validateSalaryRange() {
      const { min_salary, max_salary, salary_type } = this.formData || {};
      if (!salary_type) {
        this.$message.error("请先选择结算方式");
        return false;
      }
      if (!max_salary) {
        this.$message.error("请输入最高薪资金额");
        return false;
      }
      if (!min_salary) {
        this.$message.error("请输入最低薪资金额");
        return false;
      }
      const minVal = Number(min_salary);
      const maxVal = Number(max_salary);
      if (Number.isNaN(minVal) || Number.isNaN(maxVal)) {
        this.$message.error("薪资范围需为数字");
        return false;
      }
      if (minVal > maxVal) {
        this.$message.error("最低薪资不能高于最高薪资");
        return false;
      }
      const salaryLimits = {
        3: { min: 80, max: 5000 }, // 日结
        4: { min: 500, max: 20000 }, // 周结
        5: { min: 2000, max: 100000 }, // 月结
        1: { min: 100, max: 20000 }, // 次结
        2: { min: 10, max: 500 }, // 小时结
        6: { min: 1000, max: 500000 }, // 完工结
      };
      const limit = salaryLimits[salary_type];
      if (limit) {
        if (minVal < limit.min) {
          this.$message.error(`最低薪资为${limit.min}元`);
          return false;
        }
        if (maxVal > limit.max) {
          this.$message.error(`超出薪资上限${limit.max}元`);
          return false;
        }
      }
      return true;
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true;
      try {
        let param = {};
        if (this.formData.work_city[0]) {
          param = {
            province: this.formData.work_city[0],
            city: this.formData.work_city[1],
            area: this.formData.work_city[2],
          };
        }
        let cate_arr = [];
        if (Array.isArray(this.formData.category_ids[0])) {
          this.formData.category_ids.map((item) => {
            cate_arr.push(item[item.length - 1]);
          });
          this.formData.category_ids = cate_arr;
        }
        let res;
        if (this.id) {
          res = await this.$api.recruitTaskUpdate(this.id,{
            ...this.formData,
            ...param,
          });
        } else {
          res = await this.$api.recruitTaskAdd({
            ...this.formData,
            ...param,
          });
        }
        if (res) {
          this.$notify.success("保存成功！");
          this.$emit('confirm');
          this.handleOuterClose()
        }
        this.$nextTick(() => {
          this.loadingStaus = false;
        });
      } catch (err) {
        this.loadingStaus = false;
      }
    },
    async init() {
      if (this.id) {
        let data = await this.$api.recruitTaskDetail({ id: this.id });
        this.formData = data;
        this.formData.tag_ids = data.ph_hr_recruit_task_tag?.map((item) => item.tag_id);
        this.formData.category_ids = data.recruit_post_category_ids;
        this.formData.work_city = [data.province, data.city, data.area];
        this.formData.minimum_education = this.formData.minimum_education+'';
        // 若后端未返回岗位时效，则默认一个月
        if (!this.formData.renew_type) {
          this.formData.renew_type = 1;
        }
        if (this.formData.is_sync_alipay === undefined || this.formData.is_sync_alipay === null) {
          this.formData.is_sync_alipay = 0;
        }
      }
    },
  },
  async mounted() {
    this.loadingStaus = true;
    this.getQuickMissionList();
    this.getDailyTaskIndustryList();
    this.getDailyPostTagList();
    this.$nextTick(() => {
      this.loadingStaus = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.el-icon-warning{
  margin: 5px 0 0 4px;
  color: #409EFF;
  font-size: 18px;
}
.text-center{
  text-align: center;
}
.form-content{
  .select,.input,.cascader{
    width: 220px;
  }
  .map-picker{
    width: 220px;
  }
  .input.salary-input{
    width: 100%;
  }
 }
 .quick-create-btn{
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
}
.form-content {
  display: flex;
  flex-flow: column nowrap;
  .btn {
    display: flex;
    justify-content: center;
  }
}
</style>
